// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import WorkflowStatusView from 'pages/workflow/WorkflowStatusView';

const PayoutHistoryView = lazy(
  () => import('pages/payoutHistory/payoutHistoryView')
);
const PayoutHistoryRoute = (
  <Route path={routeName.payoutHistory}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.PAYOUT_HISTORY}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <PayoutHistoryView />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id/:calId"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.FREQUENCY_VIEW,
        //     PrivateRouteConst.SELF_FREQUENCY_DELETE,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <WorkflowStatusView />
        </Suspense>
        // </PrivateRoute>
      }
    />
  </Route>
);

export default PayoutHistoryRoute;
